// hooks/useComputedProperties.js
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import {
  buildPreviewLimit,
  previewLimitHeader,
  PREVIEW_LIMIT_STATUS,
} from '../previewLimit';

export function useComputedProperties(
  whatsappMessageLimit,
  tableData,
  totalCount,
  filters,
  // Leitura do limite falhou (useDataFetching#fetchWhatsappLimit). Sem ele o
  // `{}` do erro aparecia como "Carregando limite de mensagens..." pra sempre.
  whatsappLimitError = ref(null),
  // Leitura em andamento: `{}` aí não quer dizer "sem teto".
  whatsappLimitLoading = ref(false)
) {
  const store = useStore();
  const { t } = useI18n();

  const selectedCampaignData = computed(
    () => store.getters['campaigns/getCampaignData']
  );
  const selectedTemplate = computed(
    () => store.getters['campaigns/getTemplate']
  );

  const sealColor = computed(() => {
    const ratings = {
      GREEN: '#28a745',
      YELLOW: '#ffc107',
      RED: '#dc3545',
    };
    return ratings[whatsappMessageLimit.value?.quality_rating] || '#6c757d';
  });

  // O que a tela afirma sobre o limite sai do MESMO `buildPreviewLimit` do
  // card da prévia (previewLimit.js) — sem regra própria aqui.
  const headerContent = computed(() => {
    const preview = buildPreviewLimit({
      whatsappLimit: whatsappMessageLimit.value,
      totalCount: totalCount.value,
      error: whatsappLimitError.value,
      loading: whatsappLimitLoading.value,
    });
    const message = previewLimitHeader(preview, t);
    if (preview.status === PREVIEW_LIMIT_STATUS.ERROR) return message;
    const qualityRating = whatsappMessageLimit.value?.quality_rating || '';
    return `${message} A classificação de qualidade atual é <span class="quality-rating-bubble" style="background-color: ${sealColor.value};">${qualityRating}</span>`;
  });

  const filtersInitialData = computed(() => {
    const savedData = store.getters['campaigns/getCampaignData'];

    // Se há dados salvos de filtros, usar os dados salvos
    if (savedData.filters && savedData.filters.length > 0) {
      return savedData.filters;
    }

    // Senão, usar array vazio
    return [];
  });

  return {
    selectedCampaignData,
    selectedTemplate,
    sealColor,
    headerContent,
    filtersInitialData,
  };
}
